import { unwrapMetadataValue } from '../../components/modals/ai_metadata/utils/unwrap_metadata_value';

export function parseBooleanValue(value: unknown): boolean {
  if (typeof value === 'boolean') {
    return value;
  }
  const lowered = unwrapMetadataValue(value).toLowerCase();
  return lowered === 'true' || lowered === '1';
}
